"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRECBusinessLegalStatusLabelsMap = exports.IRECBusinessLegalStatus = void 0;
var IRECBusinessLegalStatus;
(function (IRECBusinessLegalStatus) {
    IRECBusinessLegalStatus[IRECBusinessLegalStatus["RegisteredIncorporatedBody"] = 1] = "RegisteredIncorporatedBody";
    IRECBusinessLegalStatus[IRECBusinessLegalStatus["PublicSectorEntity"] = 2] = "PublicSectorEntity";
    IRECBusinessLegalStatus[IRECBusinessLegalStatus["PrivateIndividual"] = 3] = "PrivateIndividual";
})(IRECBusinessLegalStatus = exports.IRECBusinessLegalStatus || (exports.IRECBusinessLegalStatus = {}));
exports.IRECBusinessLegalStatusLabelsMap = {
    [IRECBusinessLegalStatus.RegisteredIncorporatedBody]: 'Registered incorporated body',
    [IRECBusinessLegalStatus.PublicSectorEntity]: 'Public sector entity',
    [IRECBusinessLegalStatus.PrivateIndividual]: 'Private individual'
};
//# sourceMappingURL=BusinessLegalStatus.js.map